import { render, staticRenderFns } from "./SiestaRound.vue?vue&type=template&id=545ff587&scoped=true&"
import script from "./SiestaRound.vue?vue&type=script&lang=js&"
export * from "./SiestaRound.vue?vue&type=script&lang=js&"
import style0 from "./SiestaRound.vue?vue&type=style&index=0&id=545ff587&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545ff587",
  null
  
)

export default component.exports